(function () {
  var cfg = window.__HAVIN_ADS__ || {};
  var API = String(cfg.api || "https://api.havin.in").replace(/\/$/, "");
  var seenImpressions = {};

  function css() {
    if (document.getElementById("havin-ads-discovery-css")) return;
    var style = document.createElement("style");
    style.id = "havin-ads-discovery-css";
    style.textContent =
      ".havin-ads-section{margin:2.5rem 0;padding:0 1.25rem}" +
      ".havin-ads-section__inner{max-width:var(--page-width,1200px);margin:0 auto}" +
      ".havin-ads-section__title{font-size:1.25rem;font-weight:700;margin:0 0 .25rem}" +
      ".havin-ads-section__hint{opacity:.7;font-size:.875rem;margin:0 0 1rem}" +
      ".havin-ads-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:1rem}" +
      "@media(min-width:750px){.havin-ads-grid{grid-template-columns:repeat(4,minmax(0,1fr))}}" +
      ".havin-ads-card{position:relative;display:flex;flex-direction:column;text-decoration:none;color:inherit;border:1px solid rgba(0,0,0,.08);border-radius:12px;overflow:hidden;background:#fff}" +
      ".havin-ads-card__media{aspect-ratio:1/1;background:#f4f4f4;display:flex;align-items:center;justify-content:center}" +
      ".havin-ads-card__media img{width:100%;height:100%;object-fit:cover}" +
      ".havin-ads-card__body{padding:.75rem}" +
      ".havin-ads-card__title{font-size:.9rem;font-weight:600;line-height:1.3;margin:0 0 .35rem}" +
      ".havin-ads-card__price{font-weight:700}" +
      ".havin-ads-badge{position:absolute;top:.6rem;left:.6rem;background:#f5c518;color:#1a1a1a;font-size:.65rem;font-weight:800;letter-spacing:.04em;text-transform:uppercase;padding:.15rem .4rem;border-radius:4px}" +
      ".havin-ads-suggest{position:absolute;z-index:50;left:0;right:0;top:calc(100% + 6px);background:#fff;border:1px solid rgba(0,0,0,.1);border-radius:12px;box-shadow:0 12px 32px rgba(0,0,0,.12);overflow:hidden}" +
      ".havin-ads-suggest a{display:flex;gap:.75rem;align-items:center;padding:.65rem .8rem;text-decoration:none;color:inherit}" +
      ".havin-ads-suggest a:hover{background:#f7f7f7}" +
      ".havin-ads-suggest img{width:40px;height:40px;object-fit:cover;border-radius:8px;background:#f4f4f4}" +
      ".havin-ads-suggest__meta{min-width:0;flex:1}" +
      ".havin-ads-suggest__title{font-size:.85rem;font-weight:600;display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
      ".havin-ads-suggest .havin-ads-badge{position:static}";
    document.head.appendChild(style);
  }

  function money(value) {
    var n = Number(value) || 0;
    try {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
      }).format(n);
    } catch (e) {
      return "₹" + n;
    }
  }

  function get(path) {
    return fetch(API + path, {
      headers: { Accept: "application/json" },
    }).then(function (res) {
      if (!res.ok) throw new Error("havin ads " + res.status);
      return res.json();
    });
  }

  function track(kind, adId) {
    if (!adId) return;
    if (kind === "impression") {
      if (seenImpressions[adId]) return;
      seenImpressions[adId] = true;
    }
    fetch(API + "/ads/" + kind, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ ad_id: adId }),
    }).catch(function () {});
  }

  function card(item) {
    var a = document.createElement("a");
    a.className = "havin-ads-card";
    a.href = item.href || "/products/" + encodeURIComponent(item.handle || "");
    a.addEventListener("click", function () {
      track("click", item.ad_id);
    });
    var media = document.createElement("div");
    media.className = "havin-ads-card__media";
    if (item.image_url) {
      var img = document.createElement("img");
      img.onerror = function () {
        var grid = a.parentNode;
        if (grid) grid.removeChild(a);
        if (grid && !grid.children.length) {
          var sec = grid.closest(".havin-ads-section");
          if (sec && sec.parentNode) sec.parentNode.removeChild(sec);
        }
      };
      img.src = item.image_url;
      img.alt = item.title || "";
      media.appendChild(img);
    }
    if (item.sponsored) {
      var badge = document.createElement("span");
      badge.className = "havin-ads-badge";
      badge.textContent = "Sponsored";
      a.appendChild(badge);
    }
    var body = document.createElement("div");
    body.className = "havin-ads-card__body";
    var title = document.createElement("p");
    title.className = "havin-ads-card__title";
    title.textContent = item.title || "";
    var price = document.createElement("p");
    price.className = "havin-ads-card__price";
    price.textContent = money(item.price);
    body.appendChild(title);
    body.appendChild(price);
    a.appendChild(media);
    a.appendChild(body);
    if (item.ad_id) track("impression", item.ad_id);
    return a;
  }

  function section(title, hint, items, id) {
    if (!items || !items.length) return;
    if (document.getElementById(id)) return;
    var wrap = document.createElement("section");
    wrap.id = id;
    wrap.className = "havin-ads-section";
    wrap.innerHTML =
      '<div class="havin-ads-section__inner">' +
      "<h2 class=\"havin-ads-section__title\"></h2>" +
      "<p class=\"havin-ads-section__hint\"></p>" +
      '<div class="havin-ads-grid"></div></div>';
    wrap.querySelector(".havin-ads-section__title").textContent = title;
    wrap.querySelector(".havin-ads-section__hint").textContent = hint;
    var grid = wrap.querySelector(".havin-ads-grid");
    items.forEach(function (item) {
      grid.appendChild(card(item));
    });
    var main =
      document.getElementById("MainContent") ||
      document.querySelector("main") ||
      document.body;
    var recs = document.querySelector("product-recommendations, .product-recommendations");
    if (recs && id.indexOf("recommend") >= 0) {
      recs.parentNode.insertBefore(wrap, recs);
    } else {
      main.insertBefore(wrap, main.firstChild);
    }
  }

  function injectSponsored() {
    get("/marketplace/sponsored?limit=8")
      .then(function (body) {
        section(
          "Sponsored on Havin",
          "Top advertised picks — higher spenders first",
          body.data || [],
          "havin-ads-sponsored"
        );
      })
      .catch(function () {});
  }

  function injectRecommendations() {
    var product = cfg.product;
    if (!product || !product.handle) return;
    var qs =
      "/marketplace/recommendations?handle=" +
      encodeURIComponent(product.handle) +
      "&shopify_product_id=" +
      encodeURIComponent(product.id || "") +
      "&limit=8";
    get(qs)
      .then(function (body) {
        section(
          "You may also like",
          "Similar category picks, with sponsored products first",
          body.data || [],
          "havin-ads-recommendations"
        );
      })
      .catch(function () {});
  }

  function bindSearch() {
    var inputs = document.querySelectorAll(
      'input[type="search"], input[name="q"], predictive-search input'
    );
    Array.prototype.forEach.call(inputs, function (input) {
      if (input.dataset.havinAdsBound) return;
      input.dataset.havinAdsBound = "1";
      var parent = input.closest("form") || input.parentElement;
      if (!parent) return;
      if (window.getComputedStyle(parent).position === "static") {
        parent.style.position = "relative";
      }
      var box = document.createElement("div");
      box.className = "havin-ads-suggest";
      box.hidden = true;
      parent.appendChild(box);
      var timer = null;
      function hide() {
        box.hidden = true;
      }
      function render(rows) {
        box.innerHTML = "";
        if (!rows.length) {
          hide();
          return;
        }
        rows.forEach(function (item) {
          var a = document.createElement("a");
          a.href = item.href || "/products/" + encodeURIComponent(item.handle || "");
          a.innerHTML =
            (item.image_url
              ? '<img src="' + item.image_url + '" alt="">'
              : "<span></span>") +
            '<span class="havin-ads-suggest__meta"><span class="havin-ads-suggest__title"></span><span>' +
            money(item.price) +
            "</span></span>";
          a.querySelector(".havin-ads-suggest__title").textContent = item.title || "";
          var thumb = a.querySelector("img");
          if (thumb) {
            thumb.onerror = function () {
              if (a.parentNode) a.parentNode.removeChild(a);
            };
          }
          if (item.sponsored) {
            var badge = document.createElement("span");
            badge.className = "havin-ads-badge";
            badge.textContent = "Ad";
            a.appendChild(badge);
          }
          a.addEventListener("mousedown", function () {
            track("click", item.ad_id);
          });
          box.appendChild(a);
        });
        box.hidden = false;
      }
      input.addEventListener("input", function () {
        var q = String(input.value || "").trim();
        window.clearTimeout(timer);
        if (q.length < 2) {
          hide();
          return;
        }
        timer = window.setTimeout(function () {
          get("/marketplace/suggestions?q=" + encodeURIComponent(q) + "&limit=8")
            .then(function (body) {
              render(body.data || []);
            })
            .catch(hide);
        }, 180);
      });
      input.addEventListener("blur", function () {
        window.setTimeout(hide, 180);
      });
    });
  }

  function start() {
    css();
    bindSearch();
    var template = String(cfg.template || "").toLowerCase();
    if (cfg.product) {
      injectRecommendations();
    }
    if (
      !cfg.product ||
      template.indexOf("index") >= 0 ||
      template.indexOf("collection") >= 0 ||
      template.indexOf("search") >= 0
    ) {
      injectSponsored();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
